export function isDevelopment() {
  return env() === 'development';
}

export function isProduction() {
  return env() === 'production';
}

function env() {
  return process.env.NODE_ENV;
}
